import React, { Component } from "react";
import Icons from "./components/Icons";
import Hero from "./components/Hero";
import About from "./components/About";
import Courses from "./components/Courses";
import Leaders from "./components/Leaders";
import FAQs from "./components/FAQs";
import Posts from "./components/Posts";
import Related from "./components/Related";
import Still from "./components/Still";
import { getRequest } from "../../utils/httpRequest";
import { AxiosResponse } from "axios";
import { errorNotification } from "../../utils/helpers";
import { CourseResource } from "../../stores/CoursesStore/Types";
import { CurrentUserResource } from "../../stores/CurrentUserStore/Types";
import { SkillArea } from "./components/Types";

interface ThoughtLeader {
  id: number;
  name: string;
  role_descriptor: string;
  image_url: string;
  image_alt: string;
  profile_path: string;
}

interface Props {
  match: {
    params: {
      slug: string;
    };
  };
  currentUser: CurrentUserResource;
}

interface State {
  loading: boolean;
  skillArea: SkillArea;
  courses: CourseResource[];
  thoughtLeaders: ThoughtLeader[];
}

class SkillAreas extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      skillArea: null,
      courses: [],
      thoughtLeaders: [],
    };
  }

  componentDidMount() {
    this.fetchSkillArea();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      this.fetchSkillArea();
    }
  }

  fetchSkillArea = () => {
    this.setState({
      loading: true,
      skillArea: null,
      courses: [],
      thoughtLeaders: [],
    });

    return getRequest(`/api/skill-areas/${this.props.match.params.slug}.json`)
      .then((response: AxiosResponse) => {
        this.setState({
          skillArea: response.data.skill_area,
          courses: response.data.courses,
          thoughtLeaders: response.data.thought_leaders,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        errorNotification(
          "Error loading skill area",
          JSON.stringify(error.response?.data || error.message),
        );
      });
  };

  render() {
    const { loading, courses, thoughtLeaders, skillArea } = this.state;
    const { currentUser } = this.props;

    if (loading) {
      return (
        <main className="skill-area-profile">
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        </main>
      );
    }

    if (!skillArea) {
      return (
        <main className="skill-area-profile">
          <section className="skill-area-profile__empty">
            <h2>Skill area not found</h2>
            <p>We could not load this skill area.</p>
          </section>
        </main>
      );
    }

    return (
      <>
        <Icons />
        <main id="main-content" className="skill-areas">
          <Hero
            totalCoursesCount={courses.length}
            courses={courses.slice(0, 3)}
            userIsInUk={currentUser?.is_in_uk}
            skillArea={skillArea}
          />
          <About skillArea={skillArea} />
          <Courses courses={courses} userIsInUk={currentUser?.is_in_uk} />
          <Leaders thoughtLeaders={thoughtLeaders} skillArea={skillArea} />
          <FAQs faqs={skillArea?.faq} />
          {skillArea?.related_posts?.length > 0 && (
            <Posts skillArea={skillArea} />
          )}
          <Related />
          <Still />
          <div className="container">
            <p className="catalogue-note">
              42courses offers {courses?.length}{" "}
              {skillArea?.course_catalogue_summary}
            </p>
          </div>
        </main>
      </>
    );
  }
}

export default SkillAreas;
